import { Tokens } from '@tmov/design-system/theme/types';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 24px;

  border-radius: 8px;
  background: ${Tokens.eixods.colors.neutral.grey[0]};

  h3 {
    text-align: center;
  }
`;

export const MedidaHeader = styled.div`
  margin-bottom: 24px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 130%;
    color: ${Tokens.eixods.colors.neutral.grey[100]};
  }
`;
